'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useConfigProviderSafe } from '@material-bank/mtag-config';
import { getSignupUrl } from '../config/config';
import { buildSignupUrl } from '../lib/buildSignupUrl';
import { navigateWithFullReferrer } from '../lib/navigateWithFullReferrer';
export type UseRegisterRedirect = {
  canRedirect: boolean;
  redirectToRegister: () => void;
};

// Sends a user to MB3 account registration, preserving the current page as the
// post-signup redirect. Used to finish provisioning an auth identity whose MB3
// registration is not yet completed (accountComplete === false).
export function useRegisterRedirect() {
  const $ = _c(5);
  const config = useConfigProviderSafe();
  const sourceId = config?.tagRef ?? null;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getSignupUrl();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const signupUrl = t0;
  let t1;
  if ($[1] !== sourceId) {
    t1 = () => {
      if (signupUrl === null) {
        return;
      }
      const url = buildSignupUrl({
        baseUrl: signupUrl,
        sourceId: sourceId ?? undefined,
        redirectUrl: window.location.href
      });
      navigateWithFullReferrer(url);
    };
    $[1] = sourceId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const redirectToRegister = t1;
  let t2;
  if ($[3] !== redirectToRegister) {
    t2 = {
      canRedirect: signupUrl !== null,
      redirectToRegister
    };
    $[3] = redirectToRegister;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}